import { faChevronDown, faChevronUp } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { DetailedHTMLProps, HTMLAttributes, useState } from 'react';
import VoxelText from './VoxelText';

export interface VoxelReadMoreProps
  extends DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  originalText: string;
  readMoreText?: string;
}

export const VoxelReadMore = React.forwardRef<HTMLDivElement, VoxelReadMoreProps>(({ originalText, readMoreText }) => {
  const [showReadMore, setShowReadMore] = useState(false);
  return (
    <VoxelText className='inline'>
      {originalText}
      {!!readMoreText?.length && !showReadMore && ('...')}
      {!!readMoreText?.length && showReadMore && (readMoreText)}
      {!!readMoreText?.length && (
        <span className='cursor-pointer hover:underline text-info-600 inline-flex items-center gap-1 ml-1' onClick={() => setShowReadMore(!showReadMore)}>
          {showReadMore ? 'View less' : 'View more'}
          <FontAwesomeIcon icon={showReadMore ? faChevronUp : faChevronDown} />
        </span>
      )}
    </VoxelText>
  );
}
);

export default VoxelReadMore;
